module.exports = __webpack_public_path__ + "img/logo.c92604c7.svg";